import * as yup from 'yup';

export default (messages, optional = false) =>
  optional
    ? yup.string(messages.required).email(messages.valid)
    : yup.string(messages.required).email(messages.valid).required(messages.required);
